import { ExecutionStateValueProvider, resolveAddressSourcable, resolveBigNumberishSourcable, resolveBooleanSourcable, } from "../state";
import { addressEqual, toChainId } from "@blockwell/chains";
import { createCallSource, createLiteralSource, createStepsSource } from "../source-util";
import BigNumber from "bignumber.js";
import { Typing } from "@blockwell/eth-types";
const erc20Handler = {
    type: "erc20",
    async checkApproval(values, requires, step, token, account, spender) {
        let decimalsSource = createLiteralSource(token.parameters.decimals);
        const [allowance, whenBelow, value] = await Promise.all([
            resolveBigNumberishSourcable(values, [
                createCallSource("allowance", createLiteralSource(token.address), [
                    account,
                    spender,
                ]),
            ], step, Typing.uint, decimalsSource).then((res) => new BigNumber(res)),
            resolveBigNumberishSourcable(values, [requires.whenBelow], step, Typing.uint, decimalsSource),
            resolveBigNumberishSourcable(values, [requires.value], step, Typing.uint, decimalsSource)
        ]);
        console.log("allowance", allowance.toString(10));
        if (whenBelow) {
            if (allowance.gte(whenBelow)) {
                return null;
            }
        }
        else if (allowance.gte(value)) {
            return null;
        }
        return {
            type: "erc20",
            chainId: toChainId(token.network),
            contractAddress: token.address,
            spender,
            value,
            account
        };
    },
};
const erc721AllHandler = {
    type: "erc721-all",
    async checkApproval(values, requires, step, token, account, spender) {
        const approved = await resolveBooleanSourcable(values, [
            createCallSource("isApprovedForAll", createLiteralSource(token.address), [
                account,
                spender,
            ]),
        ], step);
        console.log("result for isApprovedForAll", token.address, account, spender, approved);
        if (approved === true) {
            return null;
        }
        return {
            type: "erc721-all",
            chainId: toChainId(token.network),
            contractAddress: token.address,
            spender,
            account
        };
    },
};
const erc721Handler = {
    type: "erc721",
    async checkApproval(values, requires, step, token, account, spender) {
        const tokenId = await resolveBigNumberishSourcable(values, [requires.value], step);
        const operator = await resolveAddressSourcable(values, [
            createCallSource("getApproved", createLiteralSource(token.address), [
                tokenId
            ]),
        ], step);
        if (addressEqual(operator, spender)) {
            return null;
        }
        return {
            type: "erc721",
            chainId: toChainId(token.network),
            contractAddress: token.address,
            spender,
            tokenId,
            account
        };
    },
};
const stepSource = createStepsSource(1, "address");
export class ApprovalHandler {
    constructor() {
        this.api = null;
        this.handler = async (state, args) => {
            const dumbapp = state.dumbapp;
            const requires = dumbapp.requiresApproval;
            if (requires) {
                const contract = args[0].contract;
                if (!contract) {
                    return {
                        success: false,
                        code: "no_contract",
                        message: "Could not find a contract for checking approvals, some input is probably missing.",
                    };
                }
                const chainId = args[0].chainId;
                const values = new ExecutionStateValueProvider(state);
                const step = dumbapp.steps[0];
                const [token, spender] = await Promise.all([
                    resolveAddressSourcable(values, [requires.token], dumbapp.steps[0]).then((address) => this.api.getContract({
                        chainId,
                        address,
                    })),
                    resolveAddressSourcable(values, [requires.spender, stepSource], step)
                ]);
                if (!token) {
                    return {
                        success: false,
                        code: "no_approval_token",
                        message: "Could not find a token to check approval against.",
                    };
                }
                if (!spender) {
                    return {
                        success: false,
                        code: "no_approval_spender",
                        message: "Could not find a spender contract for approving.",
                    };
                }
                let handler;
                if (token.features.includes("erc20")) {
                    console.log("using erc20 handler");
                    handler = erc20Handler;
                }
                else if (token.features.includes("erc721")) {
                    if (requires.value) {
                        console.log("using erc721 handler");
                        handler = erc721Handler;
                    }
                    else {
                        console.log("using erc721-all handler");
                        handler = erc721AllHandler;
                    }
                }
                if (!handler) {
                    return {
                        success: false,
                        code: "no_approval_handler",
                        message: "No handler found for approving tokens, there may be a problem with the app configuration.",
                    };
                }
                let approve = await handler.checkApproval(values, requires, step, token, state.wallet.account, spender);
                let data = {
                    approve,
                    approvalContract: token
                };
                return {
                    success: true,
                    data
                };
            }
            return {
                success: true,
                data: {},
            };
        };
    }
    setApi(api) {
        this.api = api;
    }
}
